/**
 * OaSIS Explorer Frontend - Trial Banner Component
 * Task 29.7B: Free Trial Period
 * 
 * Subtle banner showing when trial is ending soon (3 days or less).
 * Appears at the top of pages to remind users to upgrade.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

interface TrialBannerProps {
  /** Days remaining in trial */
  daysRemaining: number;
}

/**
 * Trial Banner Component
 * Only displays when 3 or fewer days remain in trial
 */
export const TrialBanner: React.FC<TrialBannerProps> = ({ daysRemaining }) => {
  // Only show when 3 or fewer days left
  if (daysRemaining > 3) return null;

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20 py-2 px-4 text-center text-sm">
      <span className="text-amber-600 dark:text-amber-400 inline-flex items-center gap-1.5">
        <Clock size={14} />
        Your free trial ends in {daysRemaining} day{daysRemaining !== 1 ? 's' : ''}.
      </span>
      <Link 
        to="/profile#subscription" 
        className="ml-2 text-amber-700 dark:text-amber-300 hover:text-amber-800 dark:hover:text-amber-200 underline underline-offset-2"
      >
        Upgrade now
      </Link>
    </div>
  );
};

export default TrialBanner;

